var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"ips-login__footer"},[_c('div',{staticClass:"txt-center"},[_c('span',{staticClass:"fs-12"},[_vm._v("版权所有 @一爱城市服务")])])])}]

export { render, staticRenderFns }